var map = {
	"./qy0.png": "aU+b",
	"./qy1.png": "ZP4l"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wFHn";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/qy.*\.png$
// module id = wFHn
// module chunks = 3